export default {
    listagem: {
        titulo_pagina: 'Lista de Functions',
        novo: 'Cadastrar nova Function',
        table: {
            empty: 'Nenhuma Function encontrada',
            nome: 'Nome',
            url: 'URL',
            url_autenticacao: 'URL Auth',
            credencial: 'Credencial',
            classe_autenticacao: 'Classe de Autenticação',
            classe_cloud_function: 'Classe da Cloud Function',
            file_format: 'Formato de Arquivo',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Cadastrar nova Function',
            editar: 'Editar Function'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome da Function ex. TITAN Google'
            },
            url: {
                label: 'URL',
                description: 'ex: http://googlecloud.com/function'
            },
            url_autenticacao: {
                label: 'URL de autenticação',
                description: 'ex: http://googlecloud.com/auth'
            },
            classe_autenticacao: {
                label: 'Classe de autenticação',
                description: 'ex: HL7'
            },
            credencial: {
                label: 'Credencial',
                description: 'Credencial de Autenticação'
            },
            classe_montagem: {
                label: 'Classe de Montagem',
                description: 'ex: HL7v3'
            },
            classe_cloud_function: {
                label: 'Classe da CloudFunction',
                description: 'ex: GoogleCloudFunctionHandler'
            },
            formato_arquivo: {
                label: 'Formato de Arquivo',
                description: ''
            },
            credencial_incluida: {
                label: 'A credencial incluida no Parser?',
                description: 'Essa opção e marcada, quando o usuario e senha vão dentro do arquivo enviado ao apoio.'
            },
            botao_salvar : 'Salvar Function'
        },
        create: {
            success: 'Function criada com Sucesso!',
            error: 'Error ao criar Function!'
        },
        update: {
            success: 'Function editada com Sucesso!',
            error: 'Error ao editar Function!'
        }
    }
}
